/* AS-02 · GUIDE ARTICLE
   The article pattern: the answer in the first line, the consequence in the
   merchant’s terms, then what they CAN do. This is Rule 1 in prose — the copy
   is verbatim from the wireframe and must not be softened or reworded. */
import { Button, Note, PageHeader } from '@/ui'

export default function AS02Guide() {
  return (
    <section data-frame="AS-02" style={{ display: 'grid', gap: 14 }}>
      <PageHeader title="Puis-je demander un avis en échange du cadeau ?"
        aside={<span className="t-muted" style={{ fontSize: 12 }}>mis à jour le 29 août</span>} />
      <p className="t-body">Non — et c’est une bonne nouvelle pour vous.</p>
      <p className="t-body">
        Conditionner un cadeau à un avis est interdit par Google et sanctionné : avis supprimés,
        et dans les cas répétés, fiche pénalisée. C’est votre visibilité locale qui est en jeu,
        pas la nôtre.
      </p>
      <p className="t-body">
        Notre parcours contourne le problème plutôt que le risque : le cadeau est <strong>tiré au
        sort et déjà gagné</strong> avant qu’un avis soit proposé. Le client sait qu’il l’a. Il
        laisse un avis parce qu’il vient de vivre un bon moment — et ces avis-là sont plus
        chaleureux que ceux qu’on achète.
      </p>
      <Note tone="ok">
        <strong>Ce que vous pouvez faire :</strong> proposer l’avis pendant que le cadeau s’ouvre.
      </Note>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Button variant="quiet" size="sm">Voir le réglage</Button>
        <Button variant="quiet" size="sm">Ce n’a pas répondu à ma question</Button>
      </div>
    </section>
  )
}
